import BigNumber from 'bignumber.js'
import { Token } from 'config/types'
import { useIsDisabledFeaturedOnTelegram } from 'hooks/useTelegram'
import Column from 'layout/Components/Column'
import { useState } from 'react'
import { useAppSelector } from 'state'
import { useAllWageringBonusesHaveAmount } from 'state/bonus/hooks'
import { useTokenSelected } from 'state/session/hooks'
import { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import OpenEffect from 'UIKit/OpenEffect'
import { getBalanceTokenKey } from 'utils'
import WarningOnTelegram from 'views/Authentication/components/Wallet/WarningOnTelegram/WarningOnTelegram'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { PAYMENT_MODAL_THEME } from 'views/Payment/MobilePayment/components/styles'
import { useAvailableDepositTokens } from 'views/Payment/MobilePayment/hooks/useTokens'
import WithdrawForm from 'views/Payment/MobilePayment/Withdraw/WithdrawForm'
import CurrencySelectDropdown from '../components/CurrencySelectDropdown'

const Withdraw: React.FC<
  ModalProps & {
    onRedirect: (page: PaymentPageEnums) => void
  }
> = ({ onRedirect, onDismiss }) => {
  const bonuses = useAllWageringBonusesHaveAmount()
  const selectedTokenInit = useTokenSelected()
  const [selectedToken, setSelectedToken] = useState<Token>(selectedTokenInit)
  const tokenBalances = useAppSelector((state) => state.profile.balances)
  const isDisabledFeaturedOnTelegram = useIsDisabledFeaturedOnTelegram()

  const { currencies } = useAvailableDepositTokens({
    onCurrencySelect: setSelectedToken,
    selectedCurrency: selectedToken,
    isIncludeFiat: true,
  })

  return (
    <>
      <ModalHeader hideStroke titleAlign="left" colorTheme={PAYMENT_MODAL_THEME} title="Withdraw" />
      <ModalBody>
        <OpenEffect openType="grow" duration={0.4}>
          {isDisabledFeaturedOnTelegram ? (
            <WarningOnTelegram />
          ) : (
            <Column gap="var(--pm-space-component, 20px)" height="100%">
              <CurrencySelectDropdown
                isIncludeFiat
                value={selectedToken}
                onTokenChange={setSelectedToken}
                fetchTokenBalanceFn={async (token: Token) => {
                  return Promise.resolve(
                    new BigNumber(tokenBalances[getBalanceTokenKey(token.network, token.code)] || 0),
                  )
                }}
                hideNetwork={false}
                allCurrencies={currencies}
                options={currencies}
                from={PaymentPageEnums.Withdraw}
              />

              <WithdrawForm
                bonusControl={{
                  bonuses,
                }}
                onBack={onDismiss}
                onClose={onDismiss}
                onRedirectToSwap={() => onRedirect(PaymentPageEnums.Swap)}
                selectedToken={selectedToken}
              />
            </Column>
          )}
        </OpenEffect>
      </ModalBody>
    </>
  )
}

export default Withdraw
